module.exports = __webpack_public_path__ + "static/img/initboard.d55bbaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/initboard.jpg
// module id = 451
// module chunks = 11